import { render, staticRenderFns } from "./FailedVirusScan.vue?vue&type=template&id=dfd0b848&"
import script from "./FailedVirusScan.vue?vue&type=script&lang=js&"
export * from "./FailedVirusScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports